var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-scroll-container": "" } }, [
    _c("div", { attrs: { "data-scroll-section": "" } }, [
      _c(
        "div",
        {
          staticClass:
            "row justify-content-center align-items-center h-100 mt-lg-0 mt-md-5 mt-sm-0 mt-6 mb-12 pb-xxl-17 pb-lg-14",
        },
        [
          _c("div", { staticClass: "col-xxl-13 col-sm-15" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h1", { staticClass: "title-2 mt-xl-0 mt-md-10 mt-sm-6 mt-6" }, [
              _vm._v("work with me"),
            ]),
            _vm._v(" "),
            !_vm.contactForm.sent
              ? _c(
                  "form",
                  {
                    staticClass: "mt-3",
                    attrs: { action: "", method: "POST" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-xl-8 mb-sm-5" }, [
                        _c(
                          "div",
                          {
                            staticClass: "radio-wrapper",
                            attrs: { id: "reason" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "radio-button mr-sm-5 mb-sm-0 mb-3",
                                class: {
                                  "has-error": _vm.$v.contactForm.reason.$error,
                                },
                              },
                              [
                                _c("label", { attrs: { for: "wedding" } }, [
                                  _vm._v("wedding\n                    "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.contactForm.reason.$model,
                                        expression:
                                          "$v.contactForm.reason.$model",
                                      },
                                    ],
                                    attrs: {
                                      id: "wedding",
                                      type: "radio",
                                      value: "wedding",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.$v.contactForm.reason.$model,
                                        "wedding"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.$v.contactForm.reason,
                                          "$model",
                                          "wedding"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "radio" }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "radio-button mr-sm-5 mb-sm-0 mb-3",
                                class: {
                                  "has-error": _vm.$v.contactForm.reason.$error,
                                },
                              },
                              [
                                _c("label", { attrs: { for: "christening" } }, [
                                  _vm._v("christening\n                    "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.contactForm.reason.$model,
                                        expression:
                                          "$v.contactForm.reason.$model",
                                      },
                                    ],
                                    attrs: {
                                      id: "christening",
                                      type: "radio",
                                      value: "christening",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.$v.contactForm.reason.$model,
                                        "christening"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.$v.contactForm.reason,
                                          "$model",
                                          "christening"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "radio" }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "radio-button mr-sm-5 mb-sm-0 mb-3",
                                class: {
                                  "has-error": _vm.$v.contactForm.reason.$error,
                                },
                              },
                              [
                                _c("label", { attrs: { for: "corporate" } }, [
                                  _vm._v("corporate\n                    "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.contactForm.reason.$model,
                                        expression:
                                          "$v.contactForm.reason.$model",
                                      },
                                    ],
                                    attrs: {
                                      id: "corporate",
                                      type: "radio",
                                      value: "corporate",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.$v.contactForm.reason.$model,
                                        "corporate"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.$v.contactForm.reason,
                                          "$model",
                                          "corporate"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "radio" }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "radio-button mr-sm-3 mb-sm-0 mb-3",
                                class: {
                                  "has-error": _vm.$v.contactForm.reason.$error,
                                },
                              },
                              [
                                _c("label", { attrs: { for: "other" } }, [
                                  _vm._v("other\n                    "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.$v.contactForm.reason.$model,
                                        expression:
                                          "$v.contactForm.reason.$model",
                                      },
                                    ],
                                    attrs: {
                                      id: "other",
                                      type: "radio",
                                      value: "other",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.$v.contactForm.reason.$model,
                                        "other"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.$v.contactForm.reason,
                                          "$model",
                                          "other"
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "radio" }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xl-3 col-lg-5 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.when.$error,
                              "has-value": _vm.$v.contactForm.when.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.when.$error
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "when" } }, [
                              _vm._v("when"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "datepicker-in-fullscreen",
                                  rawName: "v-datepicker-in-fullscreen",
                                  value: {
                                    format: "ddd DD MMM, YYYY",
                                  },
                                  expression:
                                    "{\n                    format: 'ddd DD MMM, YYYY',\n                  }",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.when.$model,
                                  expression: "$v.contactForm.when.$model",
                                },
                              ],
                              attrs: { readonly: "", id: "when", type: "text" },
                              domProps: {
                                value: _vm.$v.contactForm.when.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.when,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-5 col-sm-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.where.$error,
                              "has-value": _vm.$v.contactForm.where.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.where.$error
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(1),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.where.$model,
                                  expression: "$v.contactForm.where.$model",
                                },
                              ],
                              attrs: { id: "where", type: "text" },
                              domProps: {
                                value: _vm.$v.contactForm.where.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.where,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xl-16 col-lg-6 col-16" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.name.$error,
                              "has-value": _vm.$v.contactForm.name.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.name.$error
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "name" } }, [
                              _vm._v("name"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.name.$model,
                                  expression: "$v.contactForm.name.$model",
                                },
                              ],
                              attrs: { id: "name", type: "text" },
                              domProps: {
                                value: _vm.$v.contactForm.name.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.name,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.email.$error,
                              "has-value": _vm.$v.contactForm.email.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.email.$error &&
                            !_vm.$v.contactForm.email.required
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.contactForm.email.$error &&
                            !_vm.$v.contactForm.email.email
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  FILL AN EMAIL\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "email" } }, [
                              _vm._v("email"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.email.$model,
                                  expression: "$v.contactForm.email.$model",
                                },
                              ],
                              attrs: { id: "email", type: "text" },
                              domProps: {
                                value: _vm.$v.contactForm.email.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.email,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "input-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.phone.$error,
                              "has-value": _vm.$v.contactForm.phone.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.phone.$error
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "phone" } }, [
                              _vm._v("tel"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.phone.$model,
                                  expression: "$v.contactForm.phone.$model",
                                },
                              ],
                              attrs: { id: "phone", type: "text" },
                              domProps: {
                                value: _vm.$v.contactForm.phone.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.phone,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-16 mt-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "textarea-wrapper label-float",
                            class: {
                              "has-error": _vm.$v.contactForm.message.$error,
                              "has-value": _vm.$v.contactForm.message.$model,
                            },
                          },
                          [
                            _vm.$v.contactForm.message.$error &&
                            !_vm.$v.contactForm.message.required
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  PLEASE FILL THIS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.contactForm.message.$error &&
                            !_vm.$v.contactForm.message.maxLength
                              ? _c("p", { staticClass: "error-msg" }, [
                                  _vm._v(
                                    "\n                  MAX @" +
                                      _vm._s(
                                        _vm.$v.contactForm.message.$params
                                          .maxLength.max
                                      ) +
                                      "\n                  CHARACTERS\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "message" } }, [
                              _vm._v("additional message"),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.$v.contactForm.message.$model,
                                  expression: "$v.contactForm.message.$model",
                                },
                              ],
                              attrs: { id: "message", cols: "30", rows: "7" },
                              domProps: {
                                value: _vm.$v.contactForm.message.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.$v.contactForm.message,
                                    "$model",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-5" }, [
                      _c("div", { staticClass: "col-16 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn-submit",
                            class: { loading: _vm.contactForm.sending },
                            attrs: { type: "submit" },
                          },
                          [
                            _c("span", { staticClass: "background" }),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c("span", { staticClass: "loader" }),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _c("div", { staticClass: "row pt-10" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xxl-9 col-xl-12 col-lg-14 d-flex flex-sm-row flex-column align-items-center justify-content-start",
                    },
                    [
                      _c("img", {
                        staticClass: "img-150 mr-sm-8",
                        attrs: {
                          src: "/site/nickyeconomou/dist/images/success.png",
                          alt: "success",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-sm-0 mt-6" }, [
                        _c("p", { staticClass: "h3 ls-10 lh-12 mb-3" }, [
                          _vm._v("Thank you for your message."),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "xxsmall ls-10 lh-15 mb-2" }, [
                          _vm._v(
                            "\n                I am excited to connect with you and discuss your photography\n                needs further. I will review your message and get back to you\n                within 24-48 hours.\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-lines",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.clearForm()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "background" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "btn-text" }, [
                              _vm._v("CLOSE"),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-sm-right" }, [
      _c(
        "a",
        {
          staticClass:
            "xxsmall font-weight-normal link-strikethrough d-sm-inline-block d-block",
          attrs: { href: "tel:+306948096537" },
        },
        [_vm._v("+30 694 809 6537")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "xxsmall font-weight-normal link-strikethrough ml-lg-12 ml-sm-6 d-sm-inline-block d-block",
          attrs: { href: "mailto:info@nickyeconomou.com" },
        },
        [_vm._v("info@nickyeconomou.com")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "where" } }, [
      _vm._v("where "),
      _c("span", [_vm._v("(city, country)")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-arrow-tail-right" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "xxsmall lh-sm-20 lh-15 mb-6" }, [
      _vm._v(
        "\n                In the meantime, feel free to browse my portfolio. "
      ),
      _c("br"),
      _vm._v(
        "\n                I look forward to the opportunity to capture your special\n                moments.\n              "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }